import * as Sentry from "@sentry/react"

import { env } from "@/lib/env"

if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnvironment ?? env.mode,
    release: env.release,

    enabled: env.isProduction,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
    replaysSessionSampleRate: 0,

    initialScope: {
      tags: { component: "frontend", product: "hwcompany" },
    },

    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      "Failed to fetch",
      /^AbortError/,
    ],
  })
}
